const REACT_APP_ENV = process.env.REACT_APP_ENV;
const REACT_APP_AWS_S3_ENDPOINT = process.env.REACT_APP_AWS_S3_ENDPOINT;
const REACT_APP_AWS_S3_ENDPOINT_TEST = process.env.REACT_APP_AWS_S3_ENDPOINT_TEST;

const REACT_AWS_S3_ENDPOINT =
	REACT_APP_ENV === "prod"
		? REACT_APP_AWS_S3_ENDPOINT
		: REACT_APP_AWS_S3_ENDPOINT_TEST;

export const getLogoUrl = (path) =>
	path ? `${REACT_AWS_S3_ENDPOINT}/${path}` : null;

export default getLogoUrl;
